import React, { useEffect, useState } from 'react';
import { fetchMonthlyReports } from '../services/api';

export default function MonthlyReports() {
    const [report, setReport] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadReports = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await fetchMonthlyReports();
            setReport(res.data);
        } catch (err) {
            setError('Failed to load reports. Please try again.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadReports();
    }, []);

    if (loading) return <p>Loading monthly reports...</p>;

    if (error) return (
        <div>
            <p style={{ color: 'red' }}>{error}</p>
            <button onClick={loadReports}>Retry</button>
        </div>
    );

    if (!report.length) return (
        <div>
            <p>No reports found.</p>
            <button onClick={loadReports}>Reload</button>
        </div>
    );

    return (
        <section className="monthly-reports">
            <h2>Monthly Reports</h2>
            <button onClick={loadReports} style={{ marginBottom: '10px' }}>
                Refresh Reports
            </button>
            <table>
                <thead>
                    <tr>
                        <th>Month</th>
                        <th>Payments</th>
                        <th>Total Amount (€)</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(report) && report.map((item) => {
                        const month = item.month || 'Unknown';
                        const count = item.count ?? 0;
                        const totalAmount = item.totalAmount ?? 0;

                        let monthName = month;
                        try {
                            monthName = new Date(`2025-${month}-01`).toLocaleString('de-DE', {
                                month: 'long',
                            });
                        } catch { }

                        return (
                            <tr key={month}>
                                <td>{monthName}</td>
                                <td>{count.toLocaleString()}</td>
                                <td>
                                    {new Intl.NumberFormat('de-DE', {
                                        style: 'currency',
                                        currency: 'EUR',
                                    }).format(totalAmount)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </section>
    );
}
